import { Platform } from 'react-native';

import { getNativeAppClientInfo } from './getNativeAppClientInfo';

/**
 * True for a phone/tablet BROWSER running the web bundle — not a native build,
 * not the native WebView (which exits via `handoffSesameToNative` instead), and
 * not the Sparta iframe (whose host owns the exit).
 *
 * UA-sniffed, not viewport-measured: a narrow desktop window is still a desktop,
 * and this decision sends the user off-site to an app store. iPadOS 13+ Safari
 * reports a "Macintosh" UA with no iPad token, so it is caught by the
 * touch-points probe rather than the platform token.
 *
 * Not memoized (unlike `getNativeAppClientInfo`) — the answer can't change
 * within a session, but computing it is one regex over a short string, cheap
 * enough to call from a render path (`DownloadPanel` does, for `showDownloadCta`).
 */
export function isMobileWeb(): boolean {
  if (Platform.OS !== 'web' || typeof navigator === 'undefined') return false;

  const { isLoadedInNativeApp, isLoadedInIframe } = getNativeAppClientInfo();
  if (isLoadedInNativeApp || isLoadedInIframe) return false;

  const ua = navigator.userAgent ?? '';
  if (/Android|iPhone|iPod|iPad/i.test(ua)) return true;
  return /Macintosh/i.test(ua) && (navigator.maxTouchPoints ?? 0) > 1;
}
